import { render } from "./myButton.vue?vue&type=template&id=2a41c422&scoped=true"
import script from "./myButton.vue?vue&type=script&lang=js"
export * from "./myButton.vue?vue&type=script&lang=js"

import "./myButton.vue?vue&type=style&index=0&id=2a41c422&lang=less&scoped=true"
import "./myButton.vue?vue&type=style&index=1&id=2a41c422&lang=less"

import exportComponent from "E:\\project\\eyes-system\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a41c422"]])

export default __exports__